import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
	Card,
	CardContent,
	makeStyles,
	CardHeader,
	Typography,
	DialogContent,
} from '@material-ui/core';
import { LoadingProps, UserDetails } from '../../@types';
import { deleteUser, getUser } from '../../axios/user';
import { blue, grey, red } from '@material-ui/core/colors';
import BackBanner from '../../common/Banners/BackBanner';
import { useEffect, useState } from 'react';
import { useCardStyles } from '../../App';
// import { ItemCardHeader } from '../../common/List/ItemCardHeader';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import theme from '../../theme';
import ItemList from '../../common/List/ItemList';
import Box from '@material-ui/core/Box';
import { MoreVert } from '@material-ui/icons';
import Popover from '@material-ui/core/Popover';
import DeleteButton from '../../common/Button/DeleteButton';
import UpdateButton from '../../common/Button/UpdateButton';
import Dialog from '@material-ui/core/Dialog';
import UpdateUser from './UpdateUser';
import DeleteItemConfirmation from '../../common/Item/DeleteItemConfirmation';
import IsLoadingHOC from '../../IsLoadingHOC';

const useStyles = makeStyles((theme) => ({
	root: {},
	media: {
		height: 0,
		paddingTop: '56.25%', // 16:9
	},
	text: {
		fontSize: '15px',
		['@media (max-width:400px)']: {
			fontSize: '5vw',
		},
	},
	editIcon: {
		color: theme.palette.common.white,
	},
	description: {
		margin: '0px',
	},
	members: {
		margin: '20px 0px 0px',
	},
	updateButton: {
		width: '100%',
		marginBottom: '10px'
	},
	deleteButton: {
		width: '100%'
	},
	popupButton: {
		width: '150px',
		padding: '10px',
		backgroundColor: theme.palette.primary.main
	}
}));

export const UserDetail = (props: LoadingProps) => {
	const classes = useStyles();
	const history = useHistory();
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
		null
	);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	// const id = open ? 'simple-popover' : undefined;
	const [openUpdate, setOpenUpdate] = useState(false);
	const [openDelete, setOpenDelete] = useState(false);
	
	const handleOpenForm = () => {
		// history.push(`/users/new`);
		handleClose()
		setOpenUpdate(true)
	};

	const handleOpenDelete = () => {
		// history.push(`/users/new`);
		handleClose()
		setOpenDelete(true)
	};

	const handleCloseUpdate = () => {
		setOpenUpdate(false)
	}


	const handleCloseDelete = () => {
		setOpenDelete(false)
	}

	const cardStyles = useCardStyles();
	const { id } = useParams<any>();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const [
		User,
		setUser,
	] = React.useState<UserDetails>({
		id: '',
		firstName: '',
		lastName: '',
		email: '',
		bio: '',
		isOwner: false
	});

	React.useEffect(() => {
		if (id) {
			props.setLoading(true)
			getUser(id).then((res: any) => {
				setUser(res.data);
				props.setLoading(false)
			}).catch((err: any) => {
				console.log(err)
				props.setLoading(false)
			});
		}
	}, [id]);

	// alert(User.firstName);
	return (
		<div className={classes.root}>

			<BackBanner title={'User Details'} />
			<Card className={cardStyles.card}>
				<Box boxShadow={4}>
					<CardHeader
						className={cardStyles.cardHeader}
						classes={{
							title: cardStyles.headerTitle,
						}}
						action={User.isOwner?
							<>
								<IconButton onClick={handleClick} aria-label='settings'>
									<MoreVert className={classes.editIcon} />
								</IconButton>
								<Popover
									id={id}
									open={open}
									anchorEl={anchorEl}
									onClose={handleClose}
									anchorOrigin={{
										vertical: 'bottom',
										horizontal: 'center',
									}}
									transformOrigin={{
										vertical: 'top',
										horizontal: 'center',
									}}
								>
									<Box className={classes.popupButton}>
										<UpdateButton className={classes.updateButton} 
											onClick={handleOpenForm}
											message='Update' />
										<DeleteButton onClick={handleOpenDelete}
											className={classes.deleteButton} 
											message='Delete' />
									</Box>
								</Popover>
							</> : <></>
						}
						title={`${User.firstName} ${User.lastName}`}
					/>
				</Box>
				<CardContent>
					<Typography variant='h5'>Bio:</Typography>
					<Box className={cardStyles.sectionContent}>
						<Typography>
							{User.bio
								? User.bio
								: 'No bio'}
						</Typography>
					</Box>

					{/* <Typography
						variant='h5'
						className={cardStyles.sectionTitle}
					>
						Members:
					</Typography>
					<Box className={cardStyles.sectionContent}>
						<ItemList
							name='Users'
							isUser={true}
							items={User.members}
						/>
					</Box> */}
				</CardContent>
			</Card>
			<Dialog
				open={openUpdate}
				fullWidth
				// className={classes.form}
				keepMounted
				onClose={handleCloseUpdate}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<UpdateUser handleClose={handleCloseUpdate} setUser={setUser} user={User} />
			</Dialog>
			<Dialog
				open={openDelete}
				// fullWidth
				// className={classes.form}
				keepMounted
				onClose={handleCloseDelete}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>	
				<DeleteItemConfirmation id={User.id} confirmationText={'Delete forever'} name="user" onSubmit={deleteUser} />
			</Dialog>
		</div>
	);
};

export default IsLoadingHOC(UserDetail);
